// extracted by mini-css-extract-plugin
export default {"mainLayout":"mainLayout_mainLayout__CW8r+"};